import React from "react";
import "./termSection.scss";
import "../../../../utils/Styles/globalclasses.scss";


const TermSection = ({ heading, text }) => {
  return (
    <div className="termsSection">
      <div className="termsSection__wrapper">
        <h4>{heading}</h4>
        <p>{text}</p>
      </div>
      <div className="termsSection__underline"></div>
    </div>
  );
};

export default TermSection;
